import classNames from "classnames";

export type ButtonVariant = "default" | "primary" | "secondary" | "danger";

type ButtonProps = {
  children: React.ReactNode;
  onClick: () => void;
  variant?: ButtonVariant;
  className?: string;
  testId?: string;
  disabled?: boolean;
  ariaLabel?: string;
};
export const Button = ({
  children,
  onClick,
  className,
  variant = "default",
  testId,
  disabled = false,
  ariaLabel,
}: ButtonProps) => {
  return (
    <button
      data-testid={testId}
      type="button"
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        "m:max-w-fit m:rounded-xs m:p-3.5 m:leading-5 m:font-normal m:tracking-0.8 m:uppercase",
        {
          "m:bg-blue-750 m:text-warmgrey-25 m:hover:bg-blue-800 m:focus:bg-blue-800 m:active:bg-blue-850 m:dark:bg-blue-850 m:dark:hover:bg-blue-750 m:dark:focus:bg-blue-750 m:dark:active:bg-blue-650":
            ["primary", "default"].includes(variant),
          "m:bg-warmgrey-50 m:text-blue-950 m:hover:bg-warmgrey-100 m:focus:bg-warmgrey-100 m:active:bg-warmgrey-200 m:dark:bg-warmgrey-900 m:dark:text-neutral-white m:dark:hover:bg-warmgrey-800 m:dark:focus:bg-warmgrey-800 m:dark:active:bg-warmgrey-700":
            variant === "secondary",
          "m:bg-red-600 m:text-neutral-white m:hover:bg-red-700 m:focus:bg-red-700 m:active:bg-red-800 m:dark:bg-red-700 m:dark:text-neutral-white m:dark:hover:bg-red-600 m:dark:focus:bg-red-600 m:dark:active:bg-red-500":
            variant === "danger",
          "m:cursor-not-allowed m:opacity-50": disabled,
        },
        className,
      )}>
      {children}
    </button>
  );
};
